define( 'GameExtender/GameExtender',['require','jquery','rehash/rehash'],function( require ){

    var $           = require('jquery');
    var rehash      = require('rehash/rehash');
    var extend      = $.extend;

    function GameExtender( opt ){

        //options
        this.options = extend(true,{

            date                  : undefined,
            enableTicketing       : false,
            enableLookin          : false

        }, opt);

    }

    GameExtender.prototype = {

        /* append AM/PM to game time */
        addFullGameTime : function( game ){

            if (game.is_tbd) {

                if (game.is_doubleheader) {

                    game.fulltime =  'Gm ' + game.game_number;

                } else {

                    game.fulltime = "TBD";
                }

            } else {

                game.fulltime = game.time === "3:33" ? "TBD" : game.time + " " + game.ampm;
            }

        },


        addCSSHooks : function( game ){

            var arr = [];
            var g = 'game';
            var resumption = '';
            var currentDate = this.options.date;

            if (game.status.is_suspended) {

                if (game.resume_date && new Date(game.resume_date).getTime() !== new Date(currentDate).getTime()) {

                    resumption = 'has_resumption';

                } else if(game.resume_date && new Date(game.resume_date).getTime() === new Date(currentDate).getTime()){

                    resumption = 'is_resumption';

                }
            }

            arr.push(g);
            arr.push( game.status.epg );
            arr.push( game.status.status.replace(/\W/g, "").toLowerCase() );
            arr.push( resumption );

            game.css = arr.join( ' ' );

        },

        addInningCSS : function( game ){

            game.inningHalf = '';

            game.inningHalf =  game.status.is_top_of_inning ? "inning top" : "inning bottom";

        },

        addMessage : function( game ){


            game.message = game.status.status;

            if(game.status.is_postponed){

                game.message = "PPD";
            }

            if( game.status.is_after_game ) {

                game.message = game.status.inning > 9 ? "F/" + game.status.inning : "Final";
            }

            if( game.status.is_completed_early ){

                game.message = "F/" + game.status.inning;

            }

            if( game.status.is_cancelled ){

                game.message = "CANCL";

            }

            if( game.status.is_suspended ){

                game.message = "SUSP";

            }

            if( game.status.is_delayed || game.status.is_delayed_start ){

                game.message = "DELAY";
            }

            if( game.status.is_forfeit ){

                game.message = "FORFT";

            }

            if( game.status.is_umpire_challenge){

                game.message = "UMP REV";

            }

            if( game.status.is_manager_challenge ){

                game.message = game.status.challenge_team_abbrev + " CHAL";

            }

            if( game.status.is_instant_replay ){

                game.message = "REVIEW";
            }



        },

        addTicket : function( game ){

            game.ticketing = this.ticketingCache && this.ticketingCache[game.game_pk];
        },

        addLookin : function(game ){

            game.lookin = this.lookinCache && (this.lookinCache.game_pk === game.game_pk) ? this.lookinCache : false;
        },

        setLookin  : function( lookin ){

            this.lookinCache = lookin;

            //console.log(this.lookinCache);
        },

        clearLookin : function(){

            this.lookinCache = {};
            //console.log('clear lookin', this.lookinCache);
        },

        setTicketCache : function( tix ){

            if (tix && tix.length) {

                // Create hash of ticketing data for faster merging with MasterScoreboard
                // TicketingClient schedule_id === MasterScoreboard game_pk
                this.ticketingCache = extend(this.ticketingCache, rehash(tix, 'schedule_id'));

            }

            //console.log(this.ticketingCache);

        },


        extendGame : function( game ){

            this.addFullGameTime( game );
            this.addCSSHooks( game );
            this.addMessage( game );
            this.addInningCSS( game );

            if(this.options.enableTicketing){
                this.addTicket(game);
            }

            this.addLookin(game);

        }


    };

    return GameExtender;

});

